import React, { useState } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment';
import 'moment/locale/ko'

import {
  Breadcrumb,
  BreadcrumbItem,
  Jumbotron,
  Button,
  Row,
  Col,
  Container,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Modal,
  FormGroup,
  Input,
  ModalHeader,
} from 'reactstrap';
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase';
import { useSelector } from 'react-redux';
import defaultAvatar from "assets/img/placeholder.jpg";
import MessageForm from './MessageForm';

function Messages({ history }) {

  const firestore = useFirestore();
  const uid = useSelector(state => state.auth.currentUser.uid);
  const currentUser = useSelector(state => state.auth.currentUser);
  console.log(uid);
  useFirestoreConnect([
    {
      collection: 'message_groups',
      where: [
        ['member_ids', 'array-contains', uid]
      ],
      orderBy: [
        ['updated_at', 'desc']
      ],
      storeAs: 'messageGroups'
    }
  ]);

  const messageGroups = useSelector(state => state.firestore.ordered.messageGroups);

  const [selectedMessageGroup, setSelectedMessageGroup] = useState(null);

  console.log('message groups = ', messageGroups);

  const renderMessageGroup = (messageGroup) => {
    return <Card key={messageGroup.id} className='mb-5'>
      <CardHeader>
        <Row>
          <Col className='d-inline-flex'>
            {messageGroup.members.filter(m => m.uid !== uid).map(member => <div key={member.uid} className='mr-3'>
              <img
                src={!member.profile_image_url || member.profile_image_url.length === 0 ? defaultAvatar : member.profile_image_url}
                className='rounded-circle'
                alt='profile'
                style={{ width: 42, height: 42 }}
              />
              <span className='ml-1 p-1 font-weight-bold'>{member.name}</span>
            </div>)}
          </Col>
          <Col className='text-right'>
            <span>
              {moment(messageGroup.updated_at?.toDate()).format('YYYY년 MM월 DD일 A hh:mm')}
            </span>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <span className='font-weight-bold'>
          {messageGroup.last_message?.split('\n').map((line, idx) => <p key={idx}>{line}</p>)}
        </span>
      </CardBody>
      <CardFooter className='text-right'>
        <Button onClick={() => openMessageModal(messageGroup)}>답글쓰기</Button>
      </CardFooter>
    </Card>
  }

  const openMessageModal = async (messageGroup) => {
    if (messageGroup) {
      setSelectedMessageGroup(messageGroup);
    } else {
      const careyou = {
        uid: 'gspUAb1ZF3VRwJ5mSAD9GqJsecO2',
        name: '(주)캐어유',
        profile_image_url: 'https://firebasestorage.googleapis.com/v0/b/careu-22d80.appspot.com/o/userdata%2FgspUAb1ZF3VRwJ5mSAD9GqJsecO2%2Fpublic%2Fprofile%2Flauncher_512.png?alt=media&token=48901028-7601-467e-90f8-eb9fb923b02e'
      };

      if (careyou.uid === uid) {
        return alert('캐어유 계정으로는 캐어유에게 메시지를 보낼 수 없습니다.');
      }

      const messageGroupRef = firestore.collection(`/message_groups/`).doc();
      const newMessageGroup = {
        id: messageGroupRef.id,
        member_ids: [careyou.uid, uid],
        members: [
          careyou,
          {
            uid,
            name: currentUser.displayName,
            profile_image_url: currentUser.photoURL
          }
        ],
      };
      // console.log('newMessageGroup = ', newMessageGroup);
      // await messageGroupRef.set(newMessageGroup);
      // const docSnap = await messageGroupRef.get();
      setSelectedMessageGroup(newMessageGroup);
    }
  }

  return (
    <Container className='content'>

      <Breadcrumb>
        <BreadcrumbItem><a href="/admin/dashboard">Home</a></BreadcrumbItem>
        <BreadcrumbItem active>캐어유에게 문의</BreadcrumbItem>
      </Breadcrumb>

      <Jumbotron>
        <h1 className="display-3">문의하기</h1>
        <p className="lead">이곳에서 운영사에게 문의할 수 있습니다.</p>
        <hr className="my-2" />
        <p>메시지를 작성해서 보내시면 답장을 받을 수 있습니다.</p>
        <p className="lead">
          <Button color="primary" className='m-1'
            onClick={() => openMessageModal(null)}>캐어유에게 메시지 보내기</Button>
        </p>
      </Jumbotron>
      <div>
        {
          messageGroups?.map(messageGroup => renderMessageGroup(messageGroup))
        }
      </div>
      <Modal
        isOpen={Boolean(selectedMessageGroup)}
        toggle={() => setSelectedMessageGroup(null)}
        size='lg'
      >
        <ModalHeader toggle={() => setSelectedMessageGroup(null)}>
          메시지
        </ModalHeader>
        <MessageForm
          messageGroup={selectedMessageGroup}
          toggle={() => setSelectedMessageGroup(null)}
        />
      </Modal>
    </Container>
  )
}

Messages.propTypes = {

}

export default Messages

